<script>
export default {
  name: 'ScenarioItem',
  props: {
    scenario: {
      type: Object,
      required: true,
    },
  },
}
</script>
<template>
  <div class="scenario-item">
    <span class="scenario-title">{{ scenario.name }}</span>
    <span class="scenario-legend">{{ $gettext(scenario.helpText) }}</span>
  </div>
</template>
<style lang="scss" scoped>
.scenario-item {
  display: grid;
  grid-template-areas: "scenario-title scenario-legend";
  grid-template-columns: 100px 1fr;
  gap: 2rem;
  align-items: center;
}
.scenario-title {
  grid-area: 'scenario-title';
  font-weight: bold;
}
.scenario-legend {
  grid-area: 'scenario-legend';
  font-size: 0.85rem;
}
:deep(.v-label) {
  margin-left: 0.5ch;
}
</style>
